<!-- Είδος Παραστατικου
Σειρά
Αριθμός
Ημερομηνία Καταχώρησης
Ημερομηνία Έκδοσης 
Υποκατάστημα - Εγκατάσταση
-->

<!-- <p-fieldset legend="Παραστατικό">
    <div class="flex flex-col gap-3">
        <z-aade-invoice-type [label]="''"></z-aade-invoice-type>
        <z-date-picker></z-date-picker>
    </div>
</p-fieldset> -->
<!-- <div class="flex flex-column gap-5"></div> -->
<div
    class="flex flex-row flex-wrap gap-5 justify-between"
    stykle="border-bottom: 1px solid gray"
>
    <div class="flex flex-row grow gap-5 flex-wrap">
        <!-- <z-aade-invoice-type></z-aade-invoice-type> -->
        <z-invoice-series-info
            [formControlName]="'_id'"
        ></z-invoice-series-info>
        <!-- <ng-container [formGroupName]="'UsersActions'"></ng-container> -->
        <!-- [floatLabelVariant]="'in'" -->

        <z-invoice-card-customer
            class="flex grow flex-row gap-2"
            #invoiceCardCustomer
            [disabled]="disableCustomer()"
            [selectedCustomer]="selectedCustomer()"
            (customerSelected)="customerSelected.emit($event)"
        ></z-invoice-card-customer>

        <z-date-picker
            class="flex flex-none align-self-center"
            [floatLabelVariant]="'on'"
            [label]="'Ημερομηνία Έκδοσης'"
            [showIcon]="true"
            [showTime]="true"
            [formControlName]="'IssueDate'"
        ></z-date-picker>

        <div class="flex flex-col gap-5">
            <div class="flex flex-row">
                @if (
                    invoiceTypeCode() == '1.1' || invoiceTypeCode() == '11.1'
                ) {
                    <z-checkbox
                        [label]="'Δελτίο Διακίνησης'"
                        formControlName="IsDeliveryNote"
                        title="Επιλέξτε για να ορίσετε το παραστατικό και ως Δελτίο Διακίνησης."
                        (valueChange)="isDeliveryNoteValueChange($event)"
                    ></z-checkbox>
                }
            </div>
            <div class="flex flex-row gap-5">
                @if (
                    ((invoiceTypeCode() == '1.1' ||
                        invoiceTypeCode() == '11.1') &&
                        isDeliveryNote() == true) ||
                    invoiceTypeCode() == '9.3'
                ) {
                    <z-date-picker
                        class="flex flex-none align-self-center"
                        [floatLabelVariant]="'on'"
                        [label]="'Ημερομηνία Διακίνησης'"
                        [showIcon]="true"
                        [showTime]="true"
                        [formControlName]="'DispatchDate'"
                    ></z-date-picker>
                }

                @if (
                    ((invoiceTypeCode() == '1.1' ||
                        invoiceTypeCode() == '11.1') &&
                        isDeliveryNote() == true) ||
                    invoiceTypeCode() == '9.3'
                ) {
                    <z-invoice-move-purposes [formControlName]="'MovePurpose'">
                    </z-invoice-move-purposes>
                }
            </div>
        </div>
    </div>
    <!-- <z-aade-invoice-payment class="flex flex-none"></z-aade-invoice-payment> -->
</div>
<!-- <ng-container [formGroupName]="'Response'">
        <z-float-label
            [readonly]="true"
            [formControlName]="'InvoiceMark'"
            [label]="'Αριθμός Καταχώρησης Παραστατικού (Μ.ΑΡ.Κ)'"
        ></z-float-label>
    </ng-container> -->
<!-- <ng-container [formArrayName]="'Payments'">
        <ng-container [formGroupName]="'0'">
            <z-aade-invoice-payment                
            ></z-aade-invoice-payment>
        </ng-container>
    </ng-container> -->
